<template>
  <eco-dialog
    :single="single"
    :data="data"
    :table-columns="tableColumns"
    :pagination="pagination"
    search-placeholder="名称或编码"
    dialog-title="客户对话框"
    quick-search-props="F_customer_name,F_customer_id"
    :append-to-body="appendToBody"
    :destroy-on-close="destroyOnClose"
    @load="handleLoad"
    @onConfirm="onConfirm"
    ref="ecoDialog"
    select-label="customer_name"
  />
</template>
<script>
import uc from "@/api/uc.js";

export default {
  name: "evo-customer-dialog",
  props: {
    customerSort:String,
    value: Array,
    name: String,
    single: Boolean,
    appendToBody: {
      type: Boolean,
      default: false
    },
    destroyOnClose:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: [],
      tableColumns: [
        { prop: "customer_name", label: "客户名称", width: "300" },
        { prop: "customer_id", label: "客户编码" }
      ],
      pagination: {
        page: 1,
        pageSize: 50,
        total: 0,
        showTotal: true
      }
    };
  },
  methods: {
    showDialog() {
      this.$refs.ecoDialog.showDialog();
    },
    handleLoad(queryFilter, cb) {
      if(!queryFilter.querys) {
        queryFilter.querys = [];
      }
      queryFilter.querys.push({
        group: "advance",
        operation: "LIKE",
        property: "F_customer_sort",
        relation: "AND",
        value: this.customerSort
      })

      uc.getSupplierPage(queryFilter)
        .then(data => {
          this.data = data.rows;
          this.pagination.page = data.page;
          this.pagination.pageSize = data.pageSize;
          this.pagination.total = data.total;
          cb();
        })
        .catch(err => {
          cb();
        });
    },
    onConfirm(selection) {
      this.$emit("onConfirm", selection,this.name);
      this.$emit("input", selection);
    }
  }
};
</script>
